import { notificationModule } from '@chedri/base';

export const ADD_NOTIFICATION = 'ADD_NOTIFICATION';
export const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION';

export const addNotification = notificationModule.actions.notify;

export const removeNotification = notificationModule.actions.dismiss;
